<button mat-icon-button class="close-button" (click)="close()">
  <mat-icon class="close-icon" color="warn">close</mat-icon>
</button>
<h1 matDialogTitle>{{data.title}}</h1>
<div mat-dialog-content>
    <mat-card class="p-0">
        
            <div fxLayout="row wrap" fxLayout.lt-sm="column">
              <div fxFlex="100" class="pr-1"><br></div>
              <div fxFlex="100" class="pr-1">
                <button mat-raised-button class="mb-05" color="primary"
                  (click)="$event.preventDefault(); popUpVendedor({}, true)">{{"ADD" | translate }} {{"VENDEDOR" | translate
                  }}
                </button>
                <br>
              </div>
              <div fxFlex="100" class="pr-1">
    
                <ngx-datatable class="material ml-0 mr-0" [rows]="cadastroVendedores" [headerHeight]="50" [footerHeight]="50"
                  [scrollbarH]="true" [messages]="{emptyMessage:'Nenhum Vendedor encontrado'}" [limit]="pageSizeVendedor"
                  [rowHeight]="50">
                  <ngx-datatable-column name="#" [width]="25">
                    <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                      <strong>{{ rowIndex+1 }}</strong>
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column name="Opções" [flexGrow]="1" [width]="100">
                    <ng-template let-row="row" ngx-datatable-cell-template>
                      <button mat-icon-button mat-sm-button color="primary" class="mr-1"
                        (click)="$event.preventDefault();popUpVendedor(row)">
                        <mat-icon>edit</mat-icon>
                      </button>
                      <button mat-icon-button mat-sm-button color="warn"
                        (click)="$event.preventDefault();deleteVendedor(row)">
                        <mat-icon>delete</mat-icon>
                      </button>
                    </ng-template>
                  </ngx-datatable-column>
    
                  <ngx-datatable-column name="Vendedor/Representante" [flexGrow]="1" [width]="425" >
                    <ng-template let-row="row" ngx-datatable-cell-template>
                      {{ row?.vendedor?.codigo.toString().padStart(6, '0') + '-'+ row?.vendedor?.razaoSocial }}
                    </ng-template>
                  </ngx-datatable-column>

                  <ngx-datatable-column name="E-mail" [flexGrow]="1" [width]="250" >
                    <ng-template let-row="row" ngx-datatable-cell-template>
                      {{ row?.vendedor?.email }}
                    </ng-template>
                  </ngx-datatable-column>

                  <ngx-datatable-column name="Cidade" [flexGrow]="1" [width]="250">
                    <ng-template let-row="row" ngx-datatable-cell-template>
                      {{ row?.vendedor?.cadMun?.municipio.trim() +'/'+ row?.vendedor?.cadMun?.uf }}
                    </ng-template>
                  </ngx-datatable-column>
    
                  <ngx-datatable-footer>
                    <ng-template ngx-datatable-footer-template>
                      <mat-paginator #paginatorVendedor [length]="length" fxLayoutAlign="space-around center"
                        [showFirstLastButtons]="true" [pageSize]="pageSizeVendedor"
                        [pageSizeOptions]="pageSizeOptionsVendedor"
                        (page)="pageEventVendedor = setPageSizeOptionsVendedor($event)">
                      </mat-paginator>
                    </ng-template>
                  </ngx-datatable-footer>
                </ngx-datatable>
              </div>
            </div>
          
    </mat-card>
</div>
<mat-dialog-actions>
    <div fxFlex="100" class="mt-1">
        <span fxFlex></span>
        <button mat-button color="warn" type="button" (click)="close()"><mat-icon>close</mat-icon>{{"CLOSE" | translate }}</button>
    </div>
</mat-dialog-actions>